var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comments-block"},_vm._l((_vm.comments),function(comment,index){return _c('comment-card',{key:index,attrs:{"comment":comment}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }